<template>
  <nav v-if="hasPagination" class="vm-results-pagination" :class="extraClass" :aria-label="ariaLabel">
    <ul class="pagination">
      <li class="pagination-nav-item" :class="{ disabled: !pagination?.prev_page }">
        <a v-if="pagination?.prev_page" href="#" :data-page="pagination.prev_page" class="pagination-nav-link">
          <span aria-hidden="true">‹</span>
          <span>Prev</span>
        </a>
        <span v-else class="pagination-nav-link">
          <span aria-hidden="true">‹</span>
          <span>Prev</span>
        </span>
      </li>
      <li
        v-for="item in items"
        :key="`${keyPrefix}-${item.key}`"
        class="pagination-page-item"
        :class="{ active: item.page === pagination?.current_page, disabled: item.ellipsis }"
      >
        <span v-if="item.ellipsis" class="pagination-page-link pagination-ellipsis">{{ item.label }}</span>
        <a v-else href="#" :data-page="item.page" class="pagination-page-link">{{ item.label }}</a>
      </li>
      <li class="pagination-nav-item" :class="{ disabled: !pagination?.next_page }">
        <a v-if="pagination?.next_page" href="#" :data-page="pagination.next_page" class="pagination-nav-link">
          <span>Next</span>
          <span aria-hidden="true">›</span>
        </a>
        <span v-else class="pagination-nav-link">
          <span>Next</span>
          <span aria-hidden="true">›</span>
        </span>
      </li>
    </ul>
  </nav>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  pagination: {
    type: Object,
    default: null
  },
  ariaLabel: {
    type: String,
    default: 'Pagination'
  },
  keyPrefix: {
    type: String,
    default: 'page'
  },
  extraClass: {
    type: String,
    default: ''
  }
})

const hasPagination = computed(() => (props.pagination?.total_pages || 0) > 1)
const items = computed(() => buildPaginationItems(props.pagination))

function buildPaginationItems(pagination) {
  const totalPages = pagination?.total_pages || 0
  const currentPage = pagination?.current_page || 1

  if (totalPages <= 1) {
    return []
  }

  const pages = new Set([1, totalPages, currentPage - 1, currentPage, currentPage + 1])
  const ordered = Array.from(pages)
    .filter((page) => page >= 1 && page <= totalPages)
    .sort((a, b) => a - b)

  const result = []
  ordered.forEach((page, index) => {
    const previous = ordered[index - 1]
    if (typeof previous === 'number' && page - previous > 1) {
      result.push({ key: `ellipsis-${previous}-${page}`, ellipsis: true, label: '…' })
    }

    result.push({ key: `page-${page}`, page, label: String(page), ellipsis: false })
  })

  return result
}
</script>
